<template>
    <div ref="outboundModal" class="modal fade" id="confirm_outbound_modal" tabindex="-1" role="dialog"
        aria-labelledby="createOutboundLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="d-flex justify-content-between align-items-center mb-3">
                    <h4 class="">Outbound</h4>
                    <div class="modal-header border-0 m-0 p-0 justify-content-end">
                        <button class="btn-close" id="close-outbound-btn" data-bs-dismiss="modal" aria-label="Close"
                            @click="cancelOutbound">
                            <i class="ti ti-x"></i>
                        </button>
                    </div>
                </div>
                <Form @submit="confirm_change" :validation-schema="schema">
                    <div class="modal-body confirm">
                        <div class="col-md-12">
                            <div class="row">
                                <div class="col-12">
                                    <div class="form-wrap mb-3">
                                        <label class="col-form-label">
                                            Territory
                                            <span class="text-danger">*</span>
                                        </label>
                                        <Field as="select" name="territory_id" class="form-select"
                                            v-model="outboundForm.territory_id">
                                            <option value="">-----Select-----</option>
                                            <option v-for="ter in territoryOptions" :key="ter.id" :value="ter.id">
                                                {{ ter.name }}
                                            </option>
                                        </Field>
                                        <ErrorMessage name="territory_id" class="text-danger" />
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="form-wrap mb-3">
                                        <label class="col-form-label">
                                            Sales Responsible
                                            <span class="text-danger">*</span>
                                        </label>
                                        <Field as="select" name="sales_responsible" class="form-select"
                                            v-model="outboundForm.sales_responsible"
                                            :disabled="!outboundForm.territory_id">
                                            <option value="">-----Select-----</option>
                                            <option v-for="res in territorySalesResponsibleOptions" :key="res.id" :value="res.id">
                                                {{ res.name }}
                                            </option>
                                        </Field>
                                        <ErrorMessage name="sales_responsible" class="text-danger" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex justify-content-end">
                        <button type="submit" class="btn btn-primary confirm-btn me-2">
                            Submit
                        </button>
                        <button type="button" class="btn btn-outline-secondary cancel-btn" @click="cancelOutbound">
                            Cancel
                        </button>
                    </div>
                </Form>
            </div>
        </div>
    </div>
</template>

<script>
import { onMounted, ref, computed, watch } from 'vue';
import { Form, ErrorMessage, Field } from 'vee-validate';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import * as Yup from "yup";

export default {
    components: { Form, Field, ErrorMessage },
    emits: ['created'],
    props: {
        formData: {
            type: Object,
            default: () => ({})
        },
        saleResponsibleOptions: {
            type: Array,
            default: () => []
        }
    },
    setup(props, { emit }) {
        const store = useStore();
        const router = useRouter();
        const outboundModal = ref(null);

        const outboundForm = ref({
            sales_responsible: '',
            territory_id: ''
        });

        const territoryOptions = computed(() => store.getters['organisation/getTerritories'] || []);
        const territorySalesResponsibleOptions = ref([]);

        const fetchSalesResponsibleByTerritory = async (territoryId) => {
            if (!territoryId) {
                territorySalesResponsibleOptions.value = [];
                outboundForm.value.sales_responsible = '';
                return;
            }
            try {
                const users = await store.dispatch('organisation/fetchTerritoryCompanyUsers', {
                    territoryId,
                    skipCommit: true
                });
                territorySalesResponsibleOptions.value = users || [];
                outboundForm.value.sales_responsible = '';
            } catch (e) {
                territorySalesResponsibleOptions.value = [];
                outboundForm.value.sales_responsible = '';
            }
        };

        watch(() => outboundForm.value.territory_id, (newTerritoryId) => {
            fetchSalesResponsibleByTerritory(newTerritoryId);
        });

        const schema = Yup.object().shape({
            sales_responsible: Yup.string().required("Sales Responsible is required"),
            territory_id: Yup.string().required("Territory is required")
        });

        const confirm_change = async (values) => {
            const payload = {
                sales_responsible: values.sales_responsible,
                territory_id: values.territory_id
            };

            const response = await store.dispatch("opportunity/createOutbound", {
                oppId: props.formData.id,
                payload
            });

            if (response?.status) {
                document.getElementById("close-outbound-btn").click();
                emit('created', response?.data || response);
                const newOppId = response?.opportunity_id ?? response?.data?.opportunity_id;
                if (newOppId) {
                    const url = router.resolve({
                        path: `/crm/meter-opportunities-edit/${newOppId}`
                    }).href;
                    window.open(url, "_blank");
                } else {
                    window.location.reload();
                }
            }
        };

        const cancelOutbound = () => {
            outboundForm.value.sales_responsible = '';
            outboundForm.value.territory_id = '';
            territorySalesResponsibleOptions.value = [];
            document.getElementById("close-outbound-btn").click();
        };

        const clickOutside = () => {
            outboundForm.value.sales_responsible = '';
            outboundForm.value.territory_id = '';
            territorySalesResponsibleOptions.value = [];
        };

        onMounted(async () => {
            await store.dispatch('organisation/fetchTerritories');
            if (outboundModal.value) {
                outboundModal.value.addEventListener("hidden.bs.modal", clickOutside);
            }
        });

        return {
            outboundModal,
            outboundForm,
            territoryOptions,
            territorySalesResponsibleOptions,
            schema,
            confirm_change,
            cancelOutbound
        };
    }
};
</script>
